<template>
  <div class="form-row">
    <vv-provider tag="div" rules="required" v-slot="{ errors, classes }" name=" " ref="type"
      class="form-group" :class="forBestove ? 'col-sm-4' : 'col-sm-6'">
      <label class="access-form__label">
        Marque du produit
        <abbr title="Ce champ est obligatoire">*</abbr>
      </label>
      <v-select
        :disabled="edition"
        :options="prFormInfos.brand"
        :reduce="option => option.id"
        label="name"
        v-model="params.brand_id"
        :searchable="false"
        :class="{ 'is-error': classes.invalid }"
        @search:blur="validate('type')">
      </v-select>
      <p class="mb-0">
        <small class="text-danger">{{ errors[0] }}</small>
      </p>
    </vv-provider>
    <vv-provider tag="div" :rules="{ required: forBestove }" v-slot="{ errors, classes }" name="type de produit" ref="productType"
      class="form-group" :class="forBestove ? 'col-sm-4' : 'col-sm-6'" v-show="forBestove">
      <label class="access-form__label">
        Type de produit
        <abbr title="Ce champ est obligatoire">*</abbr>
      </label>
      <v-select
        :disabled="edition"
        ref="selectProductType"
        :options="productBestoveOptions"
        :reduce="option => option.id"
        label="name"
        v-model="params.product_type"
        :searchable="false"
        :class="{ 'is-error': error.product_type || classes.invalid }"
        @search:blur="validate('productType')">
      </v-select>
      <p class="mb-0">
        <small class="text-danger">{{ errors[0] }}</small>
      </p>
      <small class="text-danger">{{ error.product_type }}</small>
    </vv-provider>
    <vv-provider tag="div" rules="required" v-slot="{ errors, classes }" name=" "
      class="form-group" :class="forBestove ? 'col-sm-4' : 'col-sm-6'" v-show="showSelectId">
      <label class="access-form__label">
        Mon produit
        <abbr title="Ce champ est obligatoire">*</abbr>
      </label>
      <v-select
        :disabled="edition"
        ref="selectProductId"
        :options="productIdOptions"
        :reduce="product => product.id"
        label="name"
        v-model="params.product_id"
        :class="{ 'is-error': error.product_id || classes.invalid }">
        <div slot="no-options">Produit non trouvé.</div>
      </v-select>
      <p class="mb-0">
        <small class="text-danger">{{ errors[0] }}</small>
      </p>
      <small class="text-danger">{{ error.product_id }}</small>
    </vv-provider>
  </div>
</template>

<script>
import selection from './selection'

export default {
  name: 'SpsSelection',
  mixins: [
    selection
  ],
  computed: {
    forBestove () {
      return this.params.brand_id === 'bestove'
    },
    showSelectId () {
      return (this.params.brand_id === 'bestove' && this.params.product_type) ||
        (this.params.brand_id && this.params.brand_id !== 'bestove')
    },
    productIdOptions () {
      if (this.forBestove && this.params.product_type) {
        return this.prFormInfos[`${this.params.product_type}_all`.toLowerCase()]
      } else if (!this.forBestove && this.params.brand_id) {
        return this.prFormInfos.foreign.filter(p => p.brand_id === this.params.brand_id)
      } else {
        return []
      }
    }
  },
  watch: {
    'params.brand_id' (value) {
      if (value === 'bestove') {
        this.$refs.selectProductType.clearSelection()
      }
      this.$refs.selectProductId.clearSelection()
    }
  }
}
</script>
